var ResizablePages = {
    init: function() {
        var pages = jQuery('div.resizable-pages > div');
        jQuery('.page-handle').remove();
        pages.css({position: 'relative'});
        pages.addClass('resizable-page');
        pages.slice(0,-1).each(function() {
            jQuery(this).append(jQuery('<div>').addClass('page-handle'));
            jQuery(this).append(jQuery('<div>').addClass('page-overlay'));
        });

        // TODO: resize pages
        var area = jQuery('.page-handle').closest('.resizable-pages');
        jQuery('.page-handle').draggable({
            containment: ".resizable-pages",
            axis: "x",
            drag: ResizablePages.performDrag,
            start: ResizablePages.startDrag,
            stop: ResizablePages.endDrag
        });

        var resizeDelay = null;
        if (jQuery('.page-handle').length > 0) {
            jQuery(window).on('resize', ResizablePages.endDrag);
            jQuery(window).on('page:load', ResizablePages.endDrag);

            // scrolling
            $('body').css('padding-bottom', '0');
            if (jQuery('.resizable-page').length > 0){
                $('.resizable-page').height(jQuery(window).height() - jQuery('.resizable-page').offset().top - jQuery('.autosave-form-toolbar').outerHeight() - 35); // Amount of padding described in resizable_pages.scss:58
                $('.resizable-page').css('overflow', 'auto');
            }
        }
    },


    performDrag: function(ev, ui) {
        var handle = jQuery(this);
        var area = handle.closest('.resizable-pages');
        var overlay = handle.closest('.resizable-page').find('.page-overlay');
        overlay.width(handle.position().left + handle.width());
    },


    startDrag: function(ev, ui) {
        var area = jQuery(this).closest('.resizable-pages');
        // jQuery(this).closest('.resizable-page').width(jQuery(this).closest('.resizable-page').width());
        // area.css('overflow', 'hidden');
        jQuery(this).closest('.resizable-page').css('overflow', 'visible');
        jQuery(this).closest('.resizable-page').find('.page-overlay').show();
        area.data('dragging', true);
        jQuery('body').css('overflow', 'hidden');
    },


    endDrag: function(ev, ui) {
        var handle = jQuery(this).is('.page-handle') ? jQuery(this) : jQuery('.page-handle').first();
        handle.closest('.resizable-page').find('.page-overlay').hide();

        // scrolling
        if (jQuery('.resizable-page').length > 0){
          $('.resizable-page').height(jQuery(window).height() - jQuery('.resizable-page').offset().top - jQuery('.autosave-form-toolbar').outerHeight() - 35); // Amount of padding described in resizable_pages.scss:58
          $('.resizable-page').css('overflow', 'auto');
        }
        var area = handle.closest('.resizable-pages');
        var areaWidth = area.width();
        var minWidth = 250; // px
        var maxWidth = areaWidth - 250; // px
        var currentPage = handle.closest('.resizable-page');
        var w = null;

        if (typeof handle.position() !== 'undefined') {
            if (area.data('dragging')) {
                w = handle.position().left + handle.outerWidth();
            } else {
                w = currentPage.outerWidth();
            }
        } else {
            return;
        }

        if (w < minWidth) {
            w = minWidth;
        } else if (w > maxWidth) {
            w = maxWidth;
        }

        // resize
        currentPage.outerWidth((w / areaWidth * 100) + '%');
        area.find('.resizable-page').last().outerWidth(((areaWidth - w) / areaWidth * 100) + '%');

        handle.css({left: 'auto', right: 0});

        jQuery('html').css('overflow', 'hidden');
        const resizeDelay = setTimeout(function(){
            jQuery('html').css('overflow', '');
        }, 400);
        if (typeof resizeDelay !== 'undefined') {
            clearTimeout(resizeDelay);
        }

        area.data('dragging', false);
        jQuery('body').css('overflow', 'initial');
    }
};

window.ResizablePages = ResizablePages;